import React from 'react'
import { Link } from 'react-router-dom'
// import _ from 'lodash'
import OnAirProgram from './OnAirProgram';
import ProgramBoxes from './ProgramBoxes';
import subjects from '~/comm'
import { connect } from 'react-redux'
import {
  onAirFM as getOnAirFM, onAirZD as getOnAirZD, selectProgramSlug, fetchProgramIfNeeded, selectEpisodeDate, fetchEpisodesIfNeeded, programWithEpisode, programEpisodeWithPlaylist
} from '../actions'
import { DateTime } from 'luxon';
import { useEffect, useInsertionEffect } from 'react';
import { selectedEpisodeDate } from '../reducers';


const Programs = (props) => {
  
  const {programsFM, programsZD, onAirFM, onAirZD, programs, selectedEpisodeDate, search, dispatch} = props
  const cdn = '/'
  
  useInsertionEffect( () => {
    const body = document.getElementsByTagName('body')[0];
    body.className = 'programs';
    return () => {
      if(body.className === 'programs')
        body.className = ''
    }
   }, [])

  useEffect( () => {
    var interval;
    interval = setInterval(getNP, 600000)
    getNP()
    subjects.currentComponent.next('programs');

    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect( () => {
    const datestring = DateTime.local().setZone("Australia/Brisbane").toISODate()

    if( onAirFM.program && onAirFM.program.slug && selectedEpisodeDate.indexOf(datestring + ' ' + onAirFM.program.start) !== 0 ) {
      dispatch(programEpisodeWithPlaylist(onAirFM.program.slug, datestring))
    }
  }, [onAirFM, selectedEpisodeDate])

  const getNP = () => {
    const { dispatch } = props;
    dispatch(getOnAirFM());
    dispatch(getOnAirZD());
  }


  if (programsFM.lastUpdated> 0 && programsZD.lastUpdated && onAirFM.program !== null && onAirZD.program !== null) {

    var reduxep, reduxplaylist
    if (programs &&
          programs[onAirFM.program.slug] &&
          programs[onAirFM.program.slug].playlists &&
          selectedEpisodeDate
    ) {
      if(programs[onAirFM.program.slug].playlists[selectedEpisodeDate] && programs[onAirFM.program.slug].playlists[selectedEpisodeDate].items ) {
        reduxep = programs[onAirFM.program.slug].episodes[selectedEpisodeDate]
        reduxplaylist = programs[onAirFM.program.slug].playlists[selectedEpisodeDate]
      }
    }

    //var titles = []
    var image

    let compareDayAndTime = function (a, b) {
      if (a.day+a.start < b.day+b.start)
        return -1
      if (a.day+a.start > b.day+b.start)
        return 1
      return 0
    }

    // let data = _.union(programsFM.items, programsZD.items)
    let data = [...programsFM.items, ...programsZD.items]
    data = data.sort( compareDayAndTime )
    data = data.filter( i => i.slug !== 'special-selections')
    // data = _.reject(data, { slug: 'special-selections' })

    const onAirKey = data.findIndex(i => i === onAirFM.program)
    // const onAirKey = _.findIndex(data, onAirFM.program )
    const nShows = data.length

    let filteredShows = null;
    if(search.searchTerm) {
      filteredShows = data.filter( i => i.name.toLowerCase().indexOf(search.searchTerm.toLowerCase()) > -1 );
      // filteredShows = _.filter(data, function(datum) {
      //   let name = datum.name.toLowerCase()
      //   return name.indexOf(search.searchTerm.toLowerCase()) > -1;
      // })
    }

    if(filteredShows) {
      data = filteredShows
    }

    const titles = data.map((item, index) => {
      item.index = index - onAirKey
      if (item.index < 0)
        item.index = item.index + nShows
      item.index = nShows - item.index
      return (
        <ProgramBoxes key={item.index} item={item} />
      )
    })

    return (
      <div className="content">
        <div className="program-list">
          <div>
            { search.searchTerm ? null :
              <OnAirProgram program={onAirFM.program} episode={reduxep} title="On-air now!" reverse="true" height="95vh" playlist={reduxplaylist}  />
            }
          </div>
          <div>
            <h2 className="ondemand-title">Latest ondemand</h2>
            <div className="ondemand-shows">{titles}</div>
          </div>
        </div>
      </div>
    )

  }
  else {
    return ( null )
  }
}

Programs.fetchData = (store) => {
  return Promise.all([
    store.dispatch(getOnAirFM()),
    store.dispatch(getOnAirZD())
  ])
}

export default connect(state => {return { programsFM: state.programsFM, programsZD: state.programsZD, onAirFM: state.onAirFM, onAirZD: state.onAirZD, programs: state.programs, search: state.search, selectedEpisodeDate: state.selectedEpisodeDate } })(Programs)
